import { Group } from "@mantine/core";
import ReadPageBtn from "Components/MantineDataTableBtns/ReadPageBtn";
import ReadSheetBtn from "Components/MantineDataTableBtns/ReadSheetBtn";
import {
  ACTIONS,
  BRAND,
  CIRCULATION_DATE,
  CLIENT,
  DRIVERS,
  LICENCE,
  LICENCE_EXPIRE_AT,
  LICENCE_GOT_AT,
  MODEL,
  PLACES,
  READY,
  REGISTRATION_NUMBER,
  SIMS,
  TAXI,
  TAXIMETER,
} from "Constant";

export const API = {
  list: "/front/taxis?index=-1",
};

export const COLUMNS = [
  {
    name: TAXI,
    selector: "taxi",
  },
  {
    name: TAXIMETER,
    selector: "taximeter",
  },
  {
    name: PLACES,
    selector: "places",
  },

  {
    name: CIRCULATION_DATE,
    selector: "circulation_date",
  },
  {
    name: LICENCE_GOT_AT,
    selector: "licence_got_at",
  },
  {
    name: LICENCE_EXPIRE_AT,
    selector: "licence_expire_at",
  },

  {
    name: DRIVERS,
    selector: "count_drivers",
  },

  {
    id: "actions",
    button: "true",
    size: 5,
    Cell: ({ row }) => {
      const { code } = row.original;
      return (
        <Group gap="xs">
          <ReadPageBtn read={`/taxi/${code}`} />
        </Group>
      );
    },
  },
];
